export default "__VITE_ASSET__360e7cb5__"